import PageTitle from '../../components/CommonComps/Titles/PageTitle';
import RetainHistoryModalsContainer from '../../components/HistoryComps/RetainComps/RetainHistoryModalsContainer';
import ShowAllRetainHistory from '../../components/HistoryComps/RetainComps/ShowAllRetainHistory';
import RetainHistoryProvider from '../../contexts/RetainHistoryProvider';

const Retain = () => {
  // rendering retain history page component here
  return (
    <>
      <PageTitle title='Retain History' />

      <RetainHistoryProvider>
        <ShowAllRetainHistory />
        <RetainHistoryModalsContainer />
      </RetainHistoryProvider>
    </>
  );
};

export default Retain;
